export function RoleIsReadOnly(id: string): boolean {
  return id === 'reader'
}
